// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"124":"96dcf2f4","239":"371ea9ec","455":"1b5e10be","801":"4553568c","977":"773d7365"}[chunkId] + ".chunk.js";
};